import React from 'react';
import { Component } from 'react';

export class LightFog extends Component {
render(){
  return (
    <div className="Icon">
     <svg version="1.1" id="fog_x5F_light" xmlns="http://www.w3.org/2000/svg" x="0px"
	 y="0px" viewBox="0 0 24 24" enableBackground="new 0 0 24 24" >
<rect fillRule="evenodd" clipRule="evenodd" fill="none" width="24" height="24"/>
<g>
	<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="12" y1="16" x2="12" y2="2">
		<stop  offset="0.25" style="stopColor:#FFFFFF;stop-opacity:0"/>
		<stop  offset="1" style="stopColor:#FFFFFF"/>
	</linearGradient>
	<path fillRule="evenodd" clipRule="evenodd" fill="url(#SVGID_1_)" d="M17.787,7.313C17.032,4.263,14.284,2,11,2
		C7.134,2,4,5.133,4,9c0,0.25,0.015,0.496,0.04,0.738C2.846,10.218,2,11.383,2,12.75C2,14.544,3.455,16,5.25,16h12.4
		c2.403,0,4.35-1.948,4.35-4.35C22,9.294,20.125,7.387,17.787,7.313z"/>
	<linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="12" y1="16" x2="12" y2="2">
		<stop  offset="0.25" style="stopColor:#1D1D33;stop-opacity:0"/>
		<stop  offset="0.7" style="stopColor:#1D1D33"/>
	</linearGradient>
	<path fill="url(#SVGID_2_)" d="M11,3c2.7609,0,5.1526,1.8724,5.8163,4.5533l0.182,0.7352l0.757,0.024
		C19.5748,8.3701,21,9.8361,21,11.65c0,1.8472-1.5028,3.35-3.35,3.35H5.25C4.0093,15,3,13.9907,3,12.75
		c0-0.921,0.5547-1.7391,1.413-2.0842l0.6991-0.2811L5.0347,9.6353C5.0114,9.4091,5,9.2013,5,9C5,5.6916,7.6916,3,11,3 M11,2
		C7.134,2,4,5.133,4,9c0,0.25,0.015,0.496,0.04,0.738C2.846,10.218,2,11.383,2,12.75C2,14.544,3.455,16,5.25,16h12.4
		c2.403,0,4.35-1.948,4.35-4.35c0-2.356-1.875-4.263-4.213-4.337C17.032,4.263,14.284,2,11,2L11,2z"/>
</g>
<g>
	<path fill="#D5DEE8" d="M11.9969,17.3595c-2.5781,0-3.8857-0.4189-5.1514-0.8237c-1.2471-0.3994-2.4248-0.7764-4.8457-0.7764
		c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5c2.5771,0,3.8848,0.4189,5.1504,0.8237
		c1.2471,0.3994,2.4248,0.7764,4.8467,0.7764s3.6006-0.377,4.8486-0.7764c1.2656-0.4048,2.5752-0.8237,5.1543-0.8237
		c0.2764,0,0.5,0.2236,0.5,0.5s-0.2236,0.5-0.5,0.5c-2.4229,0-3.6016,0.377-4.8496,0.7764
		C15.8846,16.9405,14.575,17.3595,11.9969,17.3595z"/>
</g>
<g>
	<path fill="#D5DEE8" d="M11.9969,20.3595c-0.8301,0-1.5664-0.0425-2.251-0.1299C9.4725,20.1944,9.2781,19.944,9.3133,19.67
		c0.0352-0.2744,0.2852-0.4644,0.5596-0.4326c0.6416,0.082,1.3369,0.1221,2.124,0.1221c0.6387,0,1.2109-0.0259,1.75-0.0791
		c0.2734-0.0205,0.5195,0.1738,0.5469,0.4482c0.0264,0.2749-0.1738,0.5195-0.4492,0.5469
		C13.2733,20.3321,12.6688,20.3595,11.9969,20.3595z M17.6678,19.3497c-0.2148,0-0.4141-0.1396-0.4785-0.356
		c-0.0801-0.2646,0.0703-0.5435,0.335-0.623c0.9824-0.2949,2.1553-0.5728,4.0703-0.6074c0.2861-0.0039,0.5039,0.2148,0.5088,0.4912
		c0.0049,0.2759-0.2148,0.5039-0.4912,0.5088c-1.7939,0.0322-2.8867,0.2905-3.8008,0.5654
		C17.7635,19.3429,17.7156,19.3497,17.6678,19.3497z M5.95,19.2403c-0.0439,0-0.0889-0.0059-0.1328-0.0181
		c-0.8301-0.229-1.9316-0.4629-3.8174-0.4629c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5c2.0049,0,3.1895,0.2524,4.083,0.499
		c0.2666,0.0732,0.4229,0.3486,0.3496,0.6147C6.3709,19.0948,6.1697,19.2403,5.95,19.2403z"/>
</g>
</svg>


    </div>
  );
}
}
export default LightFog;